import type { ReactElement } from "react";
import { Loader2 } from "lucide-react";

/** Viewport-centered page load spinner (stable across routes / scroll). */
export function PageSpinner(): ReactElement {
  return (
    <div className="klt-page-spinner" role="status" aria-live="polite">
      <Loader2 className="klt-page-spinner__icon h-8 w-8 animate-spin text-sky-500" aria-label="Loading" />
    </div>
  );
}
